import { BaseError } from "src/contexts/_shared/domain/errors/BaseError";

export class InvalidDocumentWithContentFileExtensionErrorFile extends BaseError {
  constructor(reason: string) {
    super(`Invalid file extension: ${reason}`);
  }
}
